import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  LayoutService,
  IDatePickerContainer,
  OnboardingService,
  ICardCollapse,
} from 'codex-lib';
import { NewEnvelopeSteps } from '../../enum/new-envelope-steps';
import { NewEnvelopeService } from '../new-envelope/new-envelope.service';
import { IDropdown } from 'codex-lib';
import { IMyDateModel } from 'angular-mydatepicker';
import { take } from 'rxjs/operators';
import {
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
} from '@angular/forms';
import { ObjectUtil } from '../ObjectUtil';
import { LanguageBase } from '../model/language';
import { DateTimeUtil } from 'src/app/util/date-time-util';
import { AuthService } from 'src/app/services/auth.service';
import { SegmentAccessType } from 'src/app/enum/segment-access-type';
import { SegmentService } from 'src/app/modules/settings/services/segment.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as R from 'ramda';
import { Subscription } from 'rxjs';
import { EnvelopeFile } from 'src/app/main-envelope/model/envelope-file.model';
import { UserTypes } from 'src/app/enum/user-types';
import { FileUtil } from 'src/app/util/file-utils';
import { FeatureEnum } from 'src/app/enum/feature.enum';
import { EnvelopeOnBoardingService } from '../services/envelope-on-boarding.service';
import { BrowserUtil } from 'src/app/util/browser-util';
import { SurvicateService } from 'src/app/services/survicate.service';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

@Component({
  selector: 'envelope-settings',
  templateUrl: './envelope-settings.component.html',
  styleUrls: ['./envelope-settings.component.scss'],
})
export class EnvelopeSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('modalOnBoarding') modalOnBoardingRef: TemplateRef<any>;

  settingsAddForm: FormGroup;
  files: File[];
  settings: any;
  languageSelected: any;
  segmentSelected: any;
  isRequiredUserSegment: boolean;
  rejectToggleSelected: boolean = false;
  previousRejectToggleSelected: boolean = null;

  languageBase: LanguageBase;
  languageEnvelopedropdown: IDropdown;
  segmentdropdown: IDropdown;
  activeModal: NgbActiveModal;
  showModal: boolean;

  filesUploadsSubscription: Subscription;
  uploads$: Array<EnvelopeFile> = [];
  envelopeFiles: EnvelopeFile[] = [];
  envelopeFilesUploads: EnvelopeFile[] = [];

  isMobile: boolean = BrowserUtil.isMobile();
  isSignFree = false;

  datePickerContainerModel: IMyDateModel;
  datePickerContainerOptions: IDatePickerContainer = {
    icon: null,
    AngularMyDpOptions: {
      firstDayOfWeek: 'su',
      dateRange: false,
      dateFormat: 'dd/mm/yyyy',
    },
    placeholder: 'codex.datePickerComponent.datePickerPlaceholder',
    model: {
      isRange: false,
    },
  };

  fileCardCollapse: ICardCollapse = {
    headerText: 'envelope.settings.atachedFiles',
    isCardBox: true,
    button: {
      placement: 'left'
    }
  }


  settingsEnvelope = {
    archives: [],
    titleEnvelope: '',
    language: '',
    segment: '',
    expiration: '',
    message: '',
    isRejectable: false,
  };

  constructor(
    private survicateService: SurvicateService,
    private translate: TranslateService,
    public layoutService: LayoutService,
    public newEnvelopeService: NewEnvelopeService,
    private authService: AuthService,
    private segmentService: SegmentService,
    private envelopeOnBoardingService: EnvelopeOnBoardingService,
    private modalService: NgbModal,
    private googleAnalitycsService: AnalyticsService
  ) {
    this.languageBase = new LanguageBase(translate);
    this.languageBase.init().pipe(take(1)).subscribe(console.log);
    this.isSignFree = this.survicateService.isSignFree();

    this.filesUploadsSubscription = this.newEnvelopeService
      .getSubjectFilesUploads()
      .subscribe((x) => {
        this.uploads$ = x;
      });
  }

  get titleEnvelope() {
    return this.settingsAddForm.get('titleEnvelope');
  }
  get language() {
    return this.settingsAddForm.get('language');
  }
  get segment() {
    return this.settingsAddForm.get('segment');
  }
  get expiration() {
    return this.settingsAddForm.get('expiration');
  }
  get message() {
    return this.settingsAddForm.get('message');
  }
  get archives() {
    return this.settingsAddForm.get('archives');
  }
  get isRejectable() {
    return this.settingsAddForm.get('isRejectable');
  }

  ngOnDestroy() { }

  ngOnInit() {
    this.languageEnvelopedropdown = {
      items: this.languageBase.list(),
      displayText: 'value',
      placeholder: this.translate.instant('selectAnItem'),
      showSearch: false,
    };
    this.segmentdropdown = {
      items: [],
      displayText: 'value',
      placeholder: this.translate.instant('selectAnItem'),
      showSearch: true,
    };

    this.settingsAddForm = this.newEnvelopeService.getModelData(
      NewEnvelopeSteps.Settings
    );

    if (ObjectUtil.isEmpty(this.settingsAddForm)) {
      this.settingsAddForm = new FormGroup({
        archives: new FormControl(this.settingsEnvelope.archives, [
          Validators.required,
        ]),
        titleEnvelope: new FormControl(this.settingsEnvelope.titleEnvelope, [
          Validators.required,
          Validators.maxLength(500),
        ]),
        language: new FormControl(this.settingsEnvelope.language, []),
        segment: new FormControl(this.settingsEnvelope.segment, [
          Validators.required,
        ]),
        expiration: new FormControl(this.settingsEnvelope.expiration, []),
        message: new FormControl(this.settingsEnvelope.message, []),
        isRejectable: new FormControl(this.settingsEnvelope.isRejectable, []),
      });
    }

    this.userSegment();

    this.validateFormValues();
    this.settingsAddForm = this.newEnvelopeService.setModelData(
      this.settingsAddForm
    );

    this.datePickerContainerOptions.AngularMyDpOptions.dateFormat =
      this.languageBase.getDateFortmatByLanguageToCodex(
        this.translate.currentLang
      );

    this.previousRejectToggleSelected = null;
  }

  onLanguageSelectItem(value) {
    this.settingsAddForm.get('language').setValue(value);
  }

  onSegmentSelectItem(value) {
    this.settingsAddForm.get('segment').setValue(value);
  }

  onExpirationSelectItem(value: IMyDateModel) {
    const newEpoc = value?.singleDate?.epoc;
    const curEpoc = this.datePickerContainerModel?.singleDate?.epoc;

    if (newEpoc !== undefined && newEpoc === curEpoc) {
      return;
    }

    this.settingsAddForm.get('expiration').setValue(value, { emitEvent: false });
    this.datePickerContainerModel = value;

    if (value && value.singleDate) {
      if (value.singleDate.epoc < DateTimeUtil.getCurrentTimestamp()) {
        this.settingsAddForm.get('expiration').setErrors({ dateInvalid: true });
      } else {
        this.googleAnalitycsService.sendEvent(
          new TrackerData(
            AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
            'Signer_NovEnv_ConfigurarExpiração'
          )
        );
      }
    }
  }

  stepBack() {
    this.layoutService.toggleLoading(true);
    this.newEnvelopeService.stepBack();
    this.layoutService.toggleLoading(false);
  }

  showModalSegment(segmentModalContent) {
    if (this.segmentdropdown.items.length < 1 && this.showModal) {
      this.activeModal = this.modalService.open(segmentModalContent);
    }
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  confirmModalYesClick() {
    this.activeModal.close();
  }

  removeFile(indexFile: number) {
    this.newEnvelopeService.deleteFilesUploads(indexFile);
    this.uploads$.splice(indexFile, 1);
    if (this.uploads$.length === 0) {
      this.stepBack();
    }
  }

  canShowUploads() {
    return R.pathOr(0, ['length'], this.uploads$) >= 1;
  }

  showSegment() {
    return this.isSignFree ? false : true;
  }

  setReplaceTitle() {
    let titleEnvelope = this.settingsAddForm.get('titleEnvelope').value;
    // Verifique se titleEnvelope é uma string antes de chamar replace
    if (typeof titleEnvelope === 'string') {
      // Substitua os caracteres desejados
      titleEnvelope = titleEnvelope.replace(/[;=]/g, '').trim();

      this.settingsAddForm.get('titleEnvelope').setValue(titleEnvelope);
    }
  }

  markAsViewed(feature: FeatureEnum) {
    this.layoutService.toggleLoading(true);

    this.envelopeOnBoardingService.maskAsViewed(feature).subscribe(
      (x) => {
        this.layoutService.toggleLoading(false);
      },
      (error: any) => {
        this.layoutService.toggleLoading(false);
      }
    );
  }

  onRejectToggle(value: boolean, isUserAction?: boolean) {
    const calledByUser =
      typeof isUserAction === 'boolean'
        ? isUserAction
        : this.previousRejectToggleSelected !== null;

    this.settingsAddForm.get('isRejectable').setValue(value);
    this.rejectToggleSelected = value;

    if (calledByUser) {
      this.googleAnalitycsService.sendEvent(
        new TrackerData(
          AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
          'Signer_NovEnv_ConfigurarRecusa',
          this.rejectToggleSelected ? 'Ativo' : 'Inativo'
        )
      );
    }

    this.previousRejectToggleSelected = value;
  }

  private setTitleEnvelope(currentTitleEnvelope: AbstractControl, file: File) {
    const nameFirstFile = R.join(
      '',
      file.name.replace(/[;=]/g, '').split('.').slice(0, -1)
    );

    if (this.archives.value.length === 0) {
      return nameFirstFile;
    }

    if (
      nameFirstFile !== currentTitleEnvelope.value &&
      currentTitleEnvelope.value !== ''
    ) {
      return currentTitleEnvelope.value;
    }

    return nameFirstFile;
  }

  private validateFormValues() {
    this.files = this.newEnvelopeService.getModelData(
      NewEnvelopeSteps.Upload
    ) as File[];
    if (!ObjectUtil.isEmpty(this.files)) {
      this.settingsAddForm.patchValue({
        archives: this.files,
        titleEnvelope: this.setTitleEnvelope(this.titleEnvelope, this.files[0]),
      });

      this.envelopeFilesUploads = this.newEnvelopeService.getFilesUploads();
      this.files.forEach((x) => {
        const file = new EnvelopeFile();
        const fileUpload = this.envelopeFilesUploads.find(
          (e) =>
            FileUtil.removeExt(e.name) === FileUtil.removeExt(x.name) &&
            e.upload
        );

        file.id = fileUpload ? fileUpload.id : null;
        file.name = x.name;
        file.upload = fileUpload ? true : false;
        file.fileAlreadySigned = fileUpload ? fileUpload.fileAlreadySigned : false

        this.envelopeFiles.push(file);
      });
      this.newEnvelopeService.setSubjectFilesUploads(this.envelopeFiles);
    }

    if (this.settingsAddForm.value['language']) {
      this.languageSelected = this.settingsAddForm.value['language'];
    } else {
      this.languageSelected = this.languageBase.getByLanguage(
        this.translate.currentLang
      );
    }

    this.onLanguageSelectItem(this.languageSelected);

    this.onExpirationSelectItem(this.settingsAddForm.value['expiration']);

    if (this.settingsAddForm.value['segment']) {
      this.segmentSelected = this.settingsAddForm.value['segment'];
    }
    this.onSegmentSelectItem(this.segmentSelected);

    this.onRejectToggle(this.settingsAddForm.value['isRejectable'], false);
  }

  private userSegment() {
    if (
      !NewEnvelopeSteps.Settings['value'] ||
      !NewEnvelopeSteps.Settings['value'].segment
    ) {
      this.segmentService.getSegments(false).subscribe((x) => {
        const items = x.map((y) => ({ id: y.id, value: y.name }));
        this.segmentdropdown = {
          items,
          displayText: 'value',
          placeholder:
            items.length > 0
              ? this.translate.instant('selectAnItem')
              : this.translate.instant(
                'settings.segment.modalAdd.noSegmentFounded'
              ),
          clearSelectionItem: true,
          showSearch: false,
        };
        this.authService.authModel.subscribe((authModel) => {
          this.isRequiredUserSegment =
            authModel.signUser.segmentAccessType ===
              SegmentAccessType.FULL_ACCESS ||
              authModel.signUser.type === UserTypes.Admin
              ? false
              : true;

          if (!this.isRequiredUserSegment) {
            this.settingsAddForm.get('segment').clearValidators();
            this.settingsAddForm.get('segment').updateValueAndValidity();
          }
          this.showModal = this.isRequiredUserSegment;

          if (
            this.segmentdropdown !== undefined &&
            this.segmentdropdown.items !== undefined
          ) {
            if (
              this.isRequiredUserSegment &&
              this.segmentdropdown.items.length === 1
            ) {
              this.segmentSelected = this.segmentdropdown.items[0];
              this.onSegmentSelectItem(this.segmentSelected);
            }
          }
        });
      });
    }
  }
}
